import React from 'react';
import { Link } from 'react-router-dom';
import { isMobileOnly } from 'react-device-detect';
import { ArrowBack } from '@material-ui/icons';

import VideoPlayer from '../../../../components/blogComponents/SimpleVideoPlayer';

import './VideoPreview.css';
import '../../../../css/utils/flex.css';


class VideoPreview extends React.Component {
  renderBackLink() {
    let linkContent = (
      <span>
        &lsaquo;&lsaquo;
        Back to My Videos
      </span>
    );
    if (isMobileOnly) {
      linkContent = (
        <div className="back-to-videos justify-center items-center">
          <ArrowBack fontSize="inherit" />
        </div>
      );
    }

    return (
      <Link to="/dashboard/videos">{linkContent}</Link>
    );
  }

  render() {
    const { video, user } = this.props;

    return (
      <div id="anchor-video-archive-video-preview">
        <div className="container">
          {isMobileOnly  && this.renderBackLink()}
          <VideoPlayer clip={video} user={user} />
          <div className="video-details">
            <div className="flex items-center">
              <h2 className="video-details-title">{video.title}</h2>
              <span>{video.date}</span>
            </div>
            <div className="video-details-description">
              <p>{video.description}</p>
            </div>
          </div>
          {!isMobileOnly  && this.renderBackLink()}
        </div>
      </div>
    );
  }
}

export default VideoPreview;
